import SnippetLink from "../Shared/Link/Link";
import { Props_SnippetHeading } from "./Heading.props";
import { CompileHeadingToSpan, CompileMarkdown } from "@ClientBase/React/ReactSnippetMDCompiler";

const SnippetHeading = (props: Props_SnippetHeading) => {
  const { eyebrow, background, heading, linkHref, linkText, linkTarget } =
    props.snippet;

  const classHeadingBackground: string = background?.value
    ? `snippet-heading--${background.value}`
    : "";

  return (
    <section className={`snippet-heading ${classHeadingBackground}`}>
      <div className="snippet-heading__container">
        <h2 className="snippet-heading__heading">
          {CompileHeadingToSpan(heading.value || "")}
        </h2>
          { eyebrow?.value &&
          <div className="snippet-heading__eyebrow">{CompileMarkdown(eyebrow.value)}</div>
        }   

        {linkHref?.value && (
          <SnippetLink
            className="snippet-heading__link"
            url={linkHref.value}
            openInNewTab={linkTarget?.value}
          >
            {linkText?.value}
          </SnippetLink>
        )}
      </div>
    </section>
  );
};
export default SnippetHeading;
